import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as fromCompanySettingsStore from '../../settings/store';
import { CompanySettings } from '../../settings/model/company-settings';

import { FeatureFlag } from '../../settings/dto/feature-flag';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  constructor(private store: Store<fromCompanySettingsStore.CompanyState>) {}

  public isNewAccountEnabled(): Observable<boolean> {
    return fromCompanySettingsStore.getSettingsFromStore(this.store).pipe(
      map((companySettings: CompanySettings) => {
        return companySettings.featureFlagMasUi === FeatureFlag.ENABLED;
      })
    );
  }
}
